export default __webpack_public_path__ + "static/media/DSC_0722.b604f674.JPG";